// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"85d9ebc1","990":"8d6c940e"}[chunkId] + ".chunk.js";
};